import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-slate-950" data-id="element-1887">
      <Navbar data-id="element-1888" />
      <main data-id="element-1889">
        <Hero data-id="element-1890" />
        <Features data-id="element-1891" />
        <Pricing data-id="element-1892" />
        <Testimonials data-id="element-1893" />
        <Contact data-id="element-1894" />
      </main>
      <Footer data-id="element-1895" />
    </motion.div>;
}